import React from "react";
import ProtectionImageMobile from "../../Assets/Images/Universal Products.png";
import ProtectionIcon from "../../Assets/Images/protection-icon.svg";
import { useTranslation } from "../../Hooks/useTranslation";

const Protection = ({ isScrollable }) => {
  const translations = useTranslation();
  return (
    <div>
      {/* Mobile + Tablet image
          - Mobile: image extends past the RIGHT edge (right-aligned crop)
          - Tablet: image left-aligned (matching other sections), full oval visible */}
      <div className="lg:hidden block -mr-4 md:mr-0 md:pl-4 md:max-w-[664px] overflow-hidden md:overflow-visible flex mb-10">
        <img
          src={ProtectionImageMobile}
          alt="Protection"
          className="w-[130%] md:w-full max-w-none md:max-w-full h-auto"
        />
      </div>

      <div className="flex items-start lg:block">
        <img src={ProtectionIcon} className="mb-4 mr-4 lg:mr-0 reveal-up reveal-delay-3" alt="" />
        <div className="universal-benefits-content reveal-up reveal-delay-4">
          <h3 className="text-[14px] lg:text-[18px] font-semibold mb-2 lg:leading-[22px] leading-[20px]">
            {translations.universeProtection_title}
          </h3>
          <p
            className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[24px] leading-[24px] mb-3 font-mobile-14"
            dangerouslySetInnerHTML={{
              __html: translations.universeProtection_desc,
            }}
          ></p>
        </div>
      </div>
    </div>
  );
};

export default Protection;
